import Tooltip from "ui/Tooltip"
// import { dateFormat } from "utils/common"
import { FlixxCurrency } from "icons"
import {
  ContentStyled,
  EarningStyled,
  PauseTooltipContent,
  PriceStyled,
  PurchasesStyled,
  ReleaseDateStyled,
  StatusCircle,
  StatusStyled
} from "./styles"
import { formatAmount } from "utils/amounts"
import { useTranslation } from "react-i18next"
import { CONTENT_STATUS } from "config/constants"

export const Content = ({
  cover,
  title = '--',
  serie = '--',
  season = 'XX',
  episode = 'XX',
  isSerie
}) => {

  const { t } = useTranslation()

  if (isSerie) return (
    <ContentStyled>
      <img src={cover} alt={title} />
      <div>
        <p>{serie}</p>
        <p>{`${t('seasonEpisode', { season, episode })}: ${title}`}</p>
      </div>
    </ContentStyled>
  )

  return (
    <ContentStyled>
      <img src={cover} alt={title} />
      <div>
        <p>{title}</p>
      </div>
    </ContentStyled>
  )
}

export const SerieTitle = ({ title = '--' }) => (
  <ContentStyled>
    <div>
      <p>{title}</p>
    </div>
  </ContentStyled>
)

export const Status = ({ status }) => {
  const { t } = useTranslation()

  if (status === CONTENT_STATUS.enabled ) return (
    <StatusStyled>
      <StatusCircle value={status} />
      {t('published')}
    </StatusStyled>
  )

  if (status === CONTENT_STATUS.paused) return (
    <StatusStyled>
      <StatusCircle value={status} />
      {t('paused')}
      <Tooltip variant='info' place='right'>
        <PauseTooltipContent>
          <h4>{t('yourContentIsPaused')}</h4>
          <p>{t('knowMoreAboutContent')}</p>
          <a href='mailto:content@flixxo.com'>{t('sendYourQuestion')}</a>
        </PauseTooltipContent>
      </Tooltip>
    </StatusStyled>
  )

  if (status === CONTENT_STATUS.cancel) return (
    <StatusStyled isGray>
      <StatusCircle value={status} />
      {t('deleted')}
    </StatusStyled>
  )

  return (
    <StatusStyled isGray>
      {t('unknown')}
    </StatusStyled>
  )
}

export const ReleaseDate = ({ status, date }) => {
  const isGray = status === 2

  const { i18n } = useTranslation()
  const dateFormat = (date) => new Intl.DateTimeFormat(i18n.language).format(new Date(date))

  return (
    <ReleaseDateStyled isGray={isGray}>
      {dateFormat(date)}
    </ReleaseDateStyled>
)}

export const Purchases = ({ status, purchases }) => {
  const isGray = status === 2

  return (
    <PurchasesStyled isGray={isGray}>
      {purchases}
    </PurchasesStyled>
)}

export const Price = ({ status, price }) => {
  const isGray = status === 2

  return (
    <PriceStyled isGray={isGray}>
      <FlixxCurrency height={10} color='gray' />
      {formatAmount(price)}
    </PriceStyled>
)}

export const Earning = ({ status, earnings }) => {
  const isGray = status === 2

  return (
    <EarningStyled isGray={isGray}>
      <FlixxCurrency height={10} />
      {formatAmount(earnings)}
    </EarningStyled>
)}
